<template>
    <div class="container mt-3">
        <h1>Cookies Policy</h1>
        <div class="introduction">
            <h2>Introduction</h2>
            <p class="spacing"> The MY D&A TRAVEL website uses cookies to store certain information. Cookies are pieces of information that a website transfers to your hard drive or mobile device to store and sometimes track information about you. Although they identify a user's device, cookies do not reveal the name, email address or other obvious identifiers of users.</p>
            <p class="spacing"> By using our website, you consent to our use of cookies in accordance with the terms of this policy.</p>
            <p class="spacing">We try to make your experience of the website simple and meaningful. When you visit our website, our server sends a cookie to your computer or mobile device (depending on how you access the MY D&A TRAVEL). A number of cookies we use last only for the duration of your web session and expire when you close your web browser. These are known as “session cookies”. Other cookies are used to remember you when you return to the App or website and will last for longer. These are known as “persistent cookies”.</p>

            <h2>Blocking cookies</h2>
            <p class="spacing"> Most browsers automatically accept cookies but, if you prefer, you can change your browser to prevent that or to notify you each time a cookie is set. You can also learn more about cookies by visiting <a href="www.allaboutcookies.org">www.allaboutcookies.org</a> which includes additional useful information on cookies and how to block cookies using different types of browsers.</p>
            <p class="spacing">Blocking all cookies will have a negative impact upon the usability of many websites.</p>
            <p class="spacing">If you block cookies, you may not be able to use all the features on our App.</p>
            <h2>Deleting cookies</h2>
            <p class="spacing">You can delete cookies already stored on your device.</p>
            <p class="spacing">Deleting cookies will have a negative impact on the usability of many websites.</p>
        </div>
        <div class="how-we-use">
            <h2>How we use cookies</h2>
            <p class="spacing">We use cookies to:</p>
            <ul>
                <li>
                    <p>remember that you have visited us before, which allows us to identify the number of unique visitors we receive. This allows us to make sure we have enough capacity for the number of users that we get.</p>
                </li>
                <li>
                    <p>customise elements of the promotional layout and/or content of the pages of the App.</p>
                </li>
                <li>
                    <p>collect information about how you use the App so that we can improve MY D&A TRAVEL and learn which parts are most useful.</p>
                </li>
            </ul>
            <p class="spacing">Some of the cookies used by our App are set by us and some are set by third-party analytics and crash/error-reporting companies as described in this policy.</p>
            <p class="spacing">The specific cookies we use:</p>
            <div id="cookie-table" class="mb-5" :style="{'width':'100%'}">
                <table :style="{'overflow-x':'auto'}">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Essential to the users</th>
                            <th>Supplied from</th>
                            <th>Expiry length</th>
                            <th>Use</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>XSRF-TOKEN</td>
                            <td>YES</td>
                            <td>Ember Technology</td>
                            <td>End of Session</td>
                            <td>This cookie is written to help with site security in preventing Cross-Site Request Forgery attacks.</td>
                        </tr>
                        <tr>
                            <td>laravel_session</td>
                            <td>YES</td>
                            <td>Ember Technology</td>
                            <td>End of Session</td>
                            <td>This is used to hold information about your current visit with us. This cookie is essential to the security and functionality of the App.</td>
                        </tr>
                        </tbody>
                    </table>
                    <h2 style="margin-top:10px">Third party cookies</h2>
                    <p>Our App and app uses the following third party cookies.</p>
                    <table :style="{'overflow-x':'auto'}">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Essential to the users</th>
                            <th>Supplied from</th>
                            <th>Expiry length</th>
                            <th>Use</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Google Analytics</td>
                            <td>YES</td>
                            <td>Google</td>
                            <td>End of Session</td>
                            <td>This cookie is used to provide information on user behaviour within the system.</td>
                        </tr>
                        </tbody>
                    </table>
            </div>
            <div>
                <h2>Our details</h2>
                <p class="spacing"> This MY D&A TRAVEL Website is owned and operated by Tayside and Central Scotland Regional Transport Partnership (Tactran). We are a local government organisation whose headquarters is at Bordeaux House, 31 Kinnoull Street, Perth PH1 5EN.  You can contact us by sending an email to <a href="mailto:support@mydandatravel.co.uk">support@mydandatravel.co.uk</a></p>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
}

</script>
